<template>
  <div id="header">
    <div class="center more-muted-background gibson py3 px3">
      <h2 class="darkblue" v-if="pageHeader == 'Dine ordre' && pagerealactivepage === 'dine ordre' "><a href="#/webshop/orders" class="no-hover mintgreen">{{ pageHeader }}</a></h2>
        <h2 class="darkblue" v-else><span>{{ pageHeader }}</span></h2>
      <div class="pb2"></div>
      <div class="shop-header flex justify-center">
        <div class="mr2">
          <a href="#/webshop/cart" class="cart-icon darkblue" title="Kurv"><i class="el-icon-shopping-cart-full"></i></a>
          <span id="totalInbox" class="relative badge badge-pill badge-danger totalCart mr1">{{cartCount}}</span>
        </div>
        <div class="mr2">
          <a href="#/webshop/wishlist" class="cart-icon darkblue" title="Ønske liste">
            <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                  width="35.000000pt" height="35.000000pt" viewBox="0 0 2048.000000 2048.000000"
                  preserveAspectRatio="xMidYMid meet">
                  <g transform="translate(0.000000,2048.000000) scale(0.100000,-0.100000)"
                  fill="#000000" stroke="none">
                  <path d="M6660 16374 c-915 -84 -1727 -468 -2350 -1110 -442 -457 -757 -1019
                  -913 -1629 -81 -315 -107 -515 -114 -866 -29 -1472 480 -2589 1852 -4059 214
                  -229 759 -769 1040 -1030 841 -782 1943 -1725 3475 -2975 107 -87 284 -233
                  393 -323 l197 -164 168 139 c92 77 343 283 557 458 1230 1006 2291 1907 2965
                  2519 686 623 1294 1228 1705 1696 679 773 1106 1463 1341 2166 161 481 233
                  994 221 1574 -6 275 -17 398 -58 615 -139 748 -504 1429 -1049 1958 -575 559
                  -1278 898 -2100 1013 -179 25 -644 30 -855 10 -853 -82 -1550 -392 -2245
                  -1000 -133 -116 -408 -392 -548 -548 -53 -60 -99 -108 -102 -108 -3 0 -49 48
                  -102 108 -144 162 -417 434 -559 557 -330 288 -600 470 -952 640 -365 177
                  -742 287 -1167 341 -120 15 -689 28 -800 18z m775 -842 c338 -53 598 -134 890
                  -278 344 -169 642 -391 991 -739 225 -224 368 -382 684 -755 128 -151 236
                  -275 240 -275 4 0 112 124 240 275 384 453 643 731 871 937 577 518 1166 788
                  1861 854 169 15 587 7 728 -16 420 -66 805 -211 1146 -430 164 -106 288 -208
                  460 -380 250 -250 386 -439 539 -750 157 -317 239 -596 279 -945 18 -156 21
                  -513 6 -695 -134 -1558 -1086 -2807 -4085 -5356 -864 -735 -2030 -1693 -2051
                  -1685 -23 9 -972 788 -1589 1305 -1876 1572 -2946 2604 -3595 3466 -588 782
                  -871 1465 -940 2270 -15 178 -12 539 5 690 60 519 244 985 554 1403 115 155
                  390 433 538 545 415 314 889 506 1412 573 164 20 648 12 816 -14z"/>
                  </g>
                  </svg>
          </a>
          <span id="totalInbox" class="relative badge badge-pill badge-danger totalWishList">{{wishListCount}}</span>
        </div>
        <div>
          <a href="#/webshop/orders" class="cart-icon darkblue" title="Ordre"><i class="el-icon-bank-card"></i></a>
          <span id="totalInbox" class="relative badge badge-pill badge-danger totalOrders">{{orderCount}}</span>
        </div>
      </div>
    </div>
    <div class="pb3"></div>
    
    <div style="display: none" class="center flex justify-center gibson px3">
      <el-breadcrumb separator=">" class="h6 breadCrumb hide">
        <el-breadcrumb-item v-for="(page,index) in pageData" :key="index" >
          <a :href="page.url" class="no-underline pointer relative">
            <span class="regular mintgreen">{{page.name}}</span>
          </a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div> 
  </div>
</template>

<script>
export default {
  name: '',
  components: {
  },
  data () {
    return {
      // loading: false,
      salesPerson: '',
      haaId: '',
      cartCount: 0,
      wishListCount: 0,
      orderCount: 0,
      pageHeader: '',
      breadCrumb: [],
      pageData: [
        {
          name: 'Webshop',
          url: '#/webshop/overview'
        },
        {
          name: 'Produkter',
          url: '#/webshop/products'
        },
        {
          // Category
          name: '',
          url: ''
        },
        {
          name: 'Kurv',
          url: ''
        },
        {
          name: 'Din indkøbskurv',
          url: ''
        },
        {
          // Product Name
          name: '',
          url: ''
        },
        {
          name: 'Dine ordre',
          url: '#/webshop/orders'
        },
        {
          // Order Id
          name: '',
          url: ''
        },
        {
          name: 'Ønskeliste',
          url: '#/webshop/wishlist'
        }
      ],
      pagerealactivepage: ''
    }
  },
  created () {
    this.salesPerson = localStorage.getItem('id_token_portal')
    this.haaId = localStorage.getItem('haaid')
    this.displayCartCount()
    this.displayWishListCount()
    this.displayOrderCount()
    this.displayPageName()
  },
  methods: {
    displayCartCount () {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetCart/' + this.haaId
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (typeof res !== 'undefined' && res !== null && res.success) {
            var dataRes = response.data.data.data[0].webshop_cart_products
            var qty = 0
            for (var i = 0; i < dataRes.length; i++) {
              qty += parseInt(dataRes[i].QUANTITY)
            }
            this.cartCount = qty
          } else {
            qty = 0
            this.cartCount = qty
            console.log('Error in displayCartCount()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    displayWishListCount () {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetWishList/' + this.haaId
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var dataRes = response.data.data.data
            var wishlistcount = []
            wishlistcount = dataRes.filter(function (a) {
              return a.ID !== null
            })
            this.wishListCount = wishlistcount.length
          } else {
            console.log('Error in displayWishListCount()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    displayOrderCount () {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetOrders/' + this.haaId + '/0'
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var total = response.data.data.total
            this.orderCount = total
          } else {
            console.log('Error in displayOrderCount()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    },
    displayPageName () {
      if (window.location.href.indexOf('products') > -1) {
        this.pageHeader = 'Brug dine glade kunder i din markedsføring'
        this.breadCrumb = [0, 1]
      } else if (window.location.href.indexOf('product') > -1) {
        this.pageHeader = 'Håndværker.dk webshop'
        this.breadCrumb = [0, 2, 5]
        this.displayProductInfo()
      } else if (window.location.href.indexOf('cart') > -1) {
        this.pageHeader = 'Kurv'
        this.breadCrumb = [0, 3]
      } else if (window.location.href.indexOf('checkout') > -1) {
        this.pageHeader = 'Din indkøbskurv'
        this.breadCrumb = [0, 4]
      } else if (window.location.href.indexOf('orders') > -1) {
        this.pageHeader = 'Dine ordre'
        this.breadCrumb = [0, 6]
      } else if (window.location.href.indexOf('order') > -1) {
        this.pageHeader = 'Dine ordre'
        this.pagerealactivepage = 'dine ordre'
        this.breadCrumb = [0, 6, 7]
        var urlStr = window.location.href
        var url = new URL(urlStr.replace('/#', ''))
        var searchParams = url.searchParams
        var id = searchParams.get('id')
        this.pageData[7].name = '#' + id
      } else if (window.location.href.indexOf('wishlist') > -1) {
        this.pageHeader = 'Din ønskeliste'
        this.breadCrumb = [0, 8]
      }
    },
    displayProductInfo () {
      var urlStr = window.location.href
      var url = new URL(urlStr.replace('/#', ''))
      var searchParams = url.searchParams
      var id = searchParams.get('id')
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetProducts/' + id + '/0/0'
      }
      this.$http.post('', data, { emulateJSON: true }).then(
        (response) => {
          var res = response.body
          if (res.success) {
            var prodCat = response.data.data[0].CATEGORY
            var prodCatId = response.data.data[0].CATEGORY_ID
            var prodName = response.data.data[0].NAME
            this.pageData[2].name = prodCat
            this.pageData[2].url = '#/webshop/products?cat_id=' + prodCatId
            this.pageData[5].name = prodName
          } else {
            console.log('Error in displayProductInfo()')
          }
        },
        (response) => {
          console.log('Error: ', response)
        }
      )
    }
  }
}
</script>
<style>
  .shop-header .cart-icon i {
    font-size: 40px;
    top: 8px;
    right: 15px;
  }
  .shop-header #totalInbox {
    position: absolute;
    z-index: 2;
    margin-top: -3px;
    margin-left: -17px;
  }
  .el-breadcrumb span.el-breadcrumb__item:last-child span {
    color: #003645;
    pointer-events: none;
  }
  .shop-header a:hover:after {
    display: none;
  }
  .el-breadcrumb__item a:hover:after {
    display: none;
  }
  div .el-pager li.active {
    color: #5cd3d2;
  }
  .fontsize15 {
    font-size: 15px;
  }
  a.termsconditions:hover {
    color: #19a3c0;
  }
  table.total-amount td {
    padding: 0.2rem 1rem;
  }
  table.total-amount td:last-child {
    padding-right: 0;
  }
  #boost-modal {
    top: 30vh;
  }
  .loader,
  .loader:before,
  .loader:after {
    border-radius: 50%;
  }
  .loader {
    color: #143130;
    font-size: 11px;
    text-indent: -99999em;
    margin: 55px auto;
    position: relative;
    width: 10em;
    height: 10em;
    box-shadow: inset 0 0 0 1em;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before,
  .loader:after {
    position: absolute;
    content: '';
  }
  .loader:before {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 10.2em 0 0 10.2em;
    top: -0.1em;
    left: -0.1em;
    -webkit-transform-origin: 5.2em 5.1em;
    transform-origin: 5.2em 5.1em;
    -webkit-animation: load2 2s infinite ease 1.5s;
    animation: load2 2s infinite ease 1.5s;
  }
  .loader:after {
    width: 5.2em;
    height: 10.2em;
    background: white;
    border-radius: 0 10.2em 10.2em 0;
    top: -0.1em;
    left: 5.1em;
    -webkit-transform-origin: 0px 5.1em;
    transform-origin: 0px 5.1em;
    -webkit-animation: load2 2s infinite ease;
    animation: load2 2s infinite ease;
  }
  @-webkit-keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load2 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @media (max-width: 52em) {
    #header .el-breadcrumb__item {
      float: unset;
      line-height: 1.5rem;
    }
    #products div.mr3 {
      margin: 0;
    }
    #products .action-button {
      padding: 1rem;
      width: 100%;
      display: block;
      text-align: center;
    }
    #products img.prod-img {
      width: 100%;
    }
    .cart div .el-table td, .cart div .el-table th, .checkout div .el-table td, .checkout div .el-table th {
      width: 33%;
    }
  }
</style>


// WEBPACK FOOTER //
// header.vue?2a57a2ea